import { conf } from '@goldblack/shared';
import { storage } from '@goldblack/client-storage';
import { log } from '@goldblack/client-utils';
import MD5 from 'crypto-js/md5';

// format = { data, meta }
var configs = { data: null, meta: null };

function get() {
    return configs;
}

function hashConfig(cfg) {
    const str = conf.stableStringify(cfg);
    return MD5(str).toString();
}

function readFromLocalStorage(env, type, service) {
    const current = storage.localStorage.getValue('config');

    // Previously saved server config: keep it and send its hash, so the server can answer "unchanged".
    if (current.data) return { method: 'cached', value: current };

    // First visit: start from the bundled seed; its hash is only used for this first check.
    const defaults = conf.configs[env][service][type];
    const value = { data: defaults, meta: { hash: hashConfig(defaults), updatedAt: Date.now() } };
    storage.localStorage.setState('config', value);

    return { method: 'created', value };
}

function load(service) {
    const { method, value } = readFromLocalStorage(process.env.NODE_ENV, 'client', service);
    configs = value;
    storage.transience.setState('config', value.data);
    log.consoleLog(`initializing config...with ${Object.keys(configs).length} configs (${method})`);
    return configs;
}

export { load, get };
